import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditCompatibilityPageNew from "../../components/CompatibilityControl/EditCompatibilityPageNew";

const EditCompatibilityPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb
        id="title"
        title2="Compatibility Users"
        link2="/compatibility-control"
        title="Edit Compatibility"
      />
      <EditCompatibilityPageNew />
    </MasterLayout>
  );
};

export default EditCompatibilityPage;
